import React from 'react';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const ValueText = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
  padding: theme.spacing(0, 0.5),
  borderRadius: theme.borderRadius.tiny,
  backgroundColor: theme.colors.brand.lightest,
  ':hover': {
    backgroundColor: theme.colors.brand.mint,
  },
}));

export const HiddenValueText = styled(Text)(({ theme }) => ({
  color: theme.colors.brand.main,
  cursor: 'pointer',
}));


export const MissingDataText = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `};
`;

interface DataDisplayValueProps {
  value: string | null;
  isVisitor: boolean;
  onShowDataClick: () => void;
}

export const DataDisplayValue: React.FC<DataDisplayValueProps> = props => {
  const {
    value,
    isVisitor,
    onShowDataClick,
  } = props;
  const { t } = useLocale();

  if (!value) {
    return (
      <MissingDataText>
        {t('widget.unitpage.investors.missingData')}
      </MissingDataText>
    );
  }

  if (isVisitor) {
    return (
      <HiddenValueText weight="bold" onClick={onShowDataClick}>
        {t('widget.unitpage.investors.showData')}
      </HiddenValueText>
    );
  }

  return (
    <ValueText weight="bold">
      {value}
    </ValueText>
  );
};
